/**
 * datetime.js
 * date and time helpers
 */

import { Types } from './constants';
import {
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
  subDays,
  subMonths,
  subYears,
  format,
  formatDuration,
  intervalToDuration
} from 'date-fns';
import locale from 'date-fns/locale/en-US'


export const dateParamFormat = 'yyyy-MM-dd';
export const calMonthFormat = 'yyyy-MM';
export const calendarMonthBuffer = 4;


export const getDatesFromRangeType = (dateRange) => {
  let startDate = null;
  let endDate = null;
  const dType = Types.DateRange;

  dateRange = (typeof(dateRange) === 'string') ?
    parseInt(dateRange) : dateRange;

  switch(dateRange) {
    case dType.THIS_MONTH:
      startDate = startOfMonth(Date.now());
      endDate = endOfMonth(Date.now());
      break;
    case dType.LAST_MONTH:
      startDate = startOfMonth(subMonths(Date.now(), 1));
      endDate = endOfMonth(subMonths(Date.now(), 1));
      break;
    case dType.LAST_30_DAYS:
      startDate = subDays(Date.now(), 30);
      endDate = new Date();
      break;
    case dType.LAST_90_DAYS:
      startDate = subDays(Date.now(), 90);
      endDate = new Date();
      break;
    case dType.THIS_YEAR:
      startDate = startOfYear(Date.now());
      endDate = endOfYear(Date.now());
      break;
    case dType.LAST_YEAR:
      startDate = startOfYear(subYears(Date.now(), 1));
      endDate = endOfYear(subYears(Date.now(), 1));
      break;
    case dType.ALL_TIME:
      break;
    case dType.CUSTOM:
      // Temporarily return an arbitrary date range
      startDate = subDays(Date.now(), 180);
      endDate = subDays(Date.now(), 30);
      break;
    default:
  }

  return { startDate, endDate };
};


export const formatDateParams = (startDate, endDate, type) => {
  return `dateRange=${type};`
    + `startDate=${format(startDate, dateParamFormat)};`
    + `endDate=${format(endDate, dateParamFormat)}`;
}


export const formatDurationHours = (hours) => {
  const hoursPart = Math.floor(hours);
  const minutesPart = Math.round((hours % 1) * 60);
  return `${hoursPart}:${minutesPart || '00'}`;
}


export const formatDistanceToNow = (date, format) => {
  const customLocale = {
    lessThanXSeconds: '{{count}}s',
    xSeconds: '{{count}}s',
    halfAMinute: '30s',
    lessThanXMinutes: '{{count}}m',
    xMinutes: '{{count}}m',
    aboutXHours: '{{count}}h',
    xHours: '{{count}}h',
    xDays: '{{count}}d',
    aboutXWeeks: '{{count}}w',
    xWeeks: '{{count}}w',
    aboutXMonths: '{{count}}m',
    xMonths: '{{count}}m',
    aboutXYears: '{{count}}y',
    xYears: '{{count}}y',
    overXYears: '{{count}}y',
    almostXYears: '{{count}}y',
  };

  const formatDistance = (token, count, options) => {
    return customLocale[token].replace('{{count}}', count);
  }
  const now = new Date();
  const isPast = date < now;


  if (!format) {
    format = ['days', 'hours', 'minutes'];
  }

  return formatDuration(
    intervalToDuration({
      start: new Date(),
      end: date
    }), { 
      format, 
      locale: {
        ...locale,
        formatDistance
      }
    }
  ) + (isPast ? ' ago' : ' from now');
}


export const formatSecondsAsTime = (seconds) => {
  const dateString = new Date(seconds * 1000).toISOString();
  const timeString = dateString.substring(seconds < 3600 ? 14 : 11, 19);
  return timeString.startsWith('0') ? timeString.substring(1) : timeString;
}